import React, { useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import CartList from "./CartList";
import { useContext } from "react";
import { AuthContext } from "../auth/AuthContext";

import logo from "../../media/kuaina-logo-gold1.png";


function Navbar() {


    const { isAuth, user, logout } = useContext(AuthContext);



  const [open, setOpen] = useState(false);
  const [cardListActive, setCardListActive] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.getElementById("mainNavbar");

      if (window.scrollY > 200) {
        navbar.classList.add("sticky-nav");
      } else {
        navbar.classList.remove("sticky-nav");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const totalQty = useSelector((state) =>
    state.cart.items.reduce((sum, item) => sum + item.qty, 0)
  );

  return (
    <div className="nav-container-bg" id="mainNavbar">
      <div className="nav-main-container">
        <div className="nav-first-row-container">
          <div className="nav-const-cols">
            <div className="search-icon-lg">
           
              <i class="fa-solid fa-magnifying-glass"></i>{" "}
            </div>

            <FaBars className="menu-icon" onClick={() => setOpen(true)} />
          </div>
          <div className="nav-const-cols">
            <div>
              {" "}
              <img src={logo}></img>{" "}
            </div>
          </div>
          <div className="nav-const-cols">
            <div className="user-icon-lg">



             {isAuth ? (
          <div className="profile-wrapper">
            <Link to="/auth/profile">
              <i class="fa-solid fa-circle-user"></i>
              <span style={{ marginLeft: "6px" }}>
                {/* {user?.name || user?.mobileNumber} */}
              </span>
            </Link>

          
          </div>
        ) : (
          <Link to="/login">
            <i className="fa-solid fa-user"></i>
          </Link>
        )}




            </div>

            <div className="search-icon-sm">
              {" "}
              <i class="fa-solid fa-magnifying-glass"></i>{" "}
            </div>

            <div
              className="cart-icon-wrapper"
              onClick={() => setCardListActive(true)}
            >
              <i class="fa-solid fa-cart-arrow-down"></i>
              {totalQty > 0 && <span className="cart-badge">{totalQty}</span>}
            </div>
          </div>
        </div>

        <div className="Nav-main-menu-container">
          <div className="nav-menu desktop-only">
            <Link to="/">HOME</Link>
            <Link to="/collection/giftbox">GIFT BOXES</Link>
            <Link to="/collection/jaiputiset">JAIPURI SETS</Link>
            <Link to="/collection/chokersets">CHOKER SETS</Link>
            <Link to="/collection/ear-rings">EARRINGS</Link>
            <Link to="/collection/bracelets">BRACELETS</Link>
            <Link to="/collection/rings">RINGS</Link>

            <Link to="/collection/bangles">BANGLES</Link>
            <Link to="/collection/nose-rings">NOSE RINGS</Link>
            <Link to="/collection/anklets">ANKLETS</Link>

            


          </div>
        </div>


        {open && <div className="overlay" onClick={() => setOpen(false)} />}






        {/* Mobile Sidebar */}

        <div className={`mobile-sidebar ${open ? "open" : ""}`}>
          <div className="sidebar-header">
            <FaTimes onClick={() => setOpen(false)} />
          </div>

          <div className="sidebar-menu">
            <Link to="/" onClick={() => setOpen(false)}>
              HOME
            </Link>
            <Link to="/collection/giftbox" onClick={() => setOpen(false)}>
              GIFT BOXES
            </Link>
            <Link to="/collection/jaiputiset" onClick={() => setOpen(false)}>
              JAIPURI SETS
            </Link>
            <Link to="/collection/chokersets" onClick={() => setOpen(false)}>
              CHOKER SETS
            </Link>
            <Link to="/collection/ear-rings" onClick={() => setOpen(false)}>
              EARRINGS
            </Link>
            <Link to="/collection/bracelets" onClick={() => setOpen(false)}>
              BRACELETS
            </Link>
            <Link to="/collection/rings" onClick={() => setOpen(false)}>
              RINGS
            </Link>
            <Link to="/collection/bangles" onClick={() => setOpen(false)}>
              BANGLES
            </Link>

           {isAuth ? (

              <div className="profile-wraper-small-phone">
                <Link to="/auth/profile"  onClick={() => setOpen(false)}>
                  <i class="fa-solid fa-circle-user"></i> Profile
                  <span style={{ marginLeft: "6px" }}>
                  </span>
                </Link>
              </div>
        ) : (
              <Link to="/login"  onClick={() => setOpen(false)} >
                <i className="fa-solid fa-user"></i> Login
              </Link>
        )}


          </div>
        </div>

        <CartList active={cardListActive} setActive={setCardListActive} />
      </div>
    </div>
  );
}

export default Navbar;
